import { createAuthClient } from 'better-auth/vue'
import { inferAdditionalFields } from 'better-auth/client/plugins'
import { anonymousClient } from 'better-auth/client/plugins'
import type { auth } from 'auth'
import { getSessionCookie, setSessionCookie } from '~/utils/cookie'

const authClient = createAuthClient({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    basePath: 'auth',
    plugins: [inferAdditionalFields<typeof auth>(), anonymousClient()],
    fetchOptions: {
        onSuccess: (ctx) => {
            // get the token from the response headers
            const authToken = ctx.response.headers.get('set-auth-token')

            // store the token securely in a first-party cookie
            if (authToken) {
                setSessionCookie(authToken)
            }
        },
        auth: {
            type: 'Bearer',
            // retrieve the token from the first-party cookie
            token: () => getSessionCookie(),
        },
    },
})

export const useAuth = () => {
    return authClient
}
